import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from './auth.service';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { TrackingService } from '../tracking/tracking.service';
import { RatingService } from '@frontend/shared';
import { BrandDisplayService, BrandEditingService } from '../branding';
import { HubService } from '../hubs';
import { NotificationService } from '../notifications';
import { SnapshotService, SurveysService } from '../surveys';
import { FormCachingService } from '../utilities';
import { ConsentService } from '../account/consent/';
import { ContributionsService } from '../contributions';
import { ProfileUserService } from '../profile-user/profile-user.service';
import { UserSettingsService } from '../user-settings';


@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  constructor(
    private http: HttpClient,
    private authService : AuthService,
    private router : Router,
    private trackingService : TrackingService,
    private ratingService : RatingService,
    private brandEditingService: BrandEditingService,
    private brandDisplayService: BrandDisplayService,
    private hubService: HubService,
    private notificationService: NotificationService,
    private snapshotService: SnapshotService,
    private surveysService: SurveysService,
    private formCachingService: FormCachingService,
    private consentService: ConsentService,
    private contributionsService: ContributionsService,
    private profileUserService: ProfileUserService,
    private userSettingsService: UserSettingsService,
  ) { }

  logout() {
    return this.http.post<any>('api/v1/frontend/logout', {}).pipe(
      catchError((error)=>this.handleError(error)),
      tap(() => {
        this.authService.removeCachedUser();
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.authService.setRouteForRedirectAfterAuth(null);
        this.trackingService.clearData();
        this.brandEditingService.clearData();
        this.brandDisplayService.clearData();
        this.ratingService.clearData();
        this.hubService.clearData();
        this.notificationService.clearData();
        this.snapshotService.clearData();
        this.surveysService.clearData();
        this.formCachingService.clearData();
        this.consentService.clearData();
        this.contributionsService.clearData();
        this.profileUserService.clearData();
        this.userSettingsService.clearData();
        this.router.navigateByUrl('/home');
      }),
      catchError(error=>this.handleError(error)),
    );
  }

  private handleError(errorResponse: HttpErrorResponse) {
    let errorMessage = 'error.something_went_wrong';
    if (!errorResponse.error || !errorResponse.error.message) {
      return throwError(errorMessage);
    }
    return throwError(errorMessage);
  }
}
